angular.module('app.admin.broadcastManager.singularOverlayService', [])
  .factory('app.admin.broadcastManager.singularOverlayService', [
    '$http',
    function ($http) {
      return {
        getOverlays: function (gameId, audioStreamId) {
          const queryUrl = window.location.api("/broadcastManager/game/" + gameId + "/singular/overlays?audio_stream_id=" + audioStreamId);

          return $http.get(queryUrl).then(response => {
            let overlayLayers = [];

            Object.keys(response).forEach(key => {
              overlayLayers.push(new SingularOverlayLayer({ name: key, subCompositions: response[key].subCompositions }));
            });

            return overlayLayers;
          });
        },

        updateOverlay: function (gameId, audioStreamId, overlayName, key, value) {
          const queryUrl = window.location.api("/broadcastManager/game/" + gameId + "/singular/overlays");

          let values = {};
          values[key] = value;

          const overlay = {
            overlayName: overlayName,
            values: values,
          }

          const payload = {
            audioStreamId: audioStreamId,
            overlays: [overlay],
          };

          return $http.put(queryUrl, payload);
        },

        toggleOverlays: function (gameId, audioStreamId, active, names) {
          const queryUrl = window.location.api("/broadcastManager/game/" + gameId + "/singular/overlays/toggle");

          const payload = {
            audioStreamId: audioStreamId,
            active: active,
            overlayNames: names
          };

          return $http.post(queryUrl, payload);
        },

        bindOverlayHeadToHeadData: function (gameId, audioStreamId) {
          const queryUrl = window.location.api("/broadcastManager/game/" + gameId + "/singular/overlay/head_to_head?audio_stream_id=" + audioStreamId);
          return $http.put(queryUrl, {});
        },

        bindModifierHeadToHeadData: function (gameId, audioStreamId) {
          const queryUrl = window.location.api("/broadcastManager/game/" + gameId + "/singular/modifier/head_to_head?audio_stream_id=" + audioStreamId);
          return $http.put(queryUrl, {});
        },

        bindOverlayTeamScheduleData: function (gameId, audioStreamId, teamId, overlayName) {
          const queryUrl = window.location.api("/broadcastManager/game/" + gameId + "/singular/overlay/team_upcoming_schedule?audio_stream_id=" + audioStreamId + "&team_id=" + teamId + "&overlay_name=" + overlayName);
          return $http.put(queryUrl, {});
        },

        bindOverlayLeagueScheduleData: function (gameId, audioStreamId, overlayName) {
          const queryUrl = window.location.api("/broadcastManager/game/" + gameId + "/singular/overlay/league_upcoming_schedule?audio_stream_id=" + audioStreamId + "&overlay_name=" + overlayName);
          return $http.put(queryUrl, {});
        },

        bindOverlayTeamLineupData: function (gameId, audioStreamId) {
          const queryUrl = window.location.api("/broadcastManager/game/" + gameId + "/singular/overlay/team_lineup?audio_stream_id=" + audioStreamId);
          return $http.put(queryUrl, {});
        },

        bindModifierPowerPlayEfficiency: function (gameId, audioStreamId, homePowerPlay) {
          const queryUrl = window.location.api("/broadcastManager/game/" + gameId + "/singular/modifier/power_play_efficiency?audio_stream_id=" + audioStreamId + "&home_power_play=" + homePowerPlay);
          return $http.put(queryUrl, {});
        },

        bindOverlayThreeStarsData: function (gameId, audioStreamId) {
          const queryUrl = window.location.api("/broadcastManager/game/" + gameId + "/singular/overlay/three_stars?audio_stream_id=" + audioStreamId);
          return $http.put(queryUrl, {});
        },

        bindOverlayUpcomingCalendarData: function (gameId, audioStreamId) {
          const queryUrl = window.location.api("/broadcastManager/game/" + gameId + "/singular/overlay/upcoming_calendar?audio_stream_id=" + audioStreamId);
          return $http.put(queryUrl, {});
        },

        bindModifierOverallTeamRecord: function (gameId, audioStreamId) {
          const queryUrl = window.location.api("/broadcastManager/game/" + gameId + "/singular/modifier/overall_team_record?audio_stream_id=" + audioStreamId);
          return $http.put(queryUrl, {});
        }

      }
    }
  ]);



// WEBPACK FOOTER //
// ./app.v2/components/admin/broadcastManager/singularOverlayService.js